<template>
    <div class="junior-total-point-input-container">
      <p>{{fromPreviousDate ? "Previous" : "Current"}} Show Year's Total Points for</p>
      <div class="select-container">
        <v-select
          outlined
          single-line
          v-model="selectedClass"
          :items="classes"
          item-value="id"
          item-text="description"
        />
      </div>
      <p>:</p>
      <p class="total-points">{{totalPoints}}</p>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import juniorHandlerService from "../../services/admin/juniorHandlerService";

export default Vue.extend({
    name: "JuniorTotalPoint",
    props: {
      personId: { type: Number },
      classes: { type: [] as any[] },
      scoreType: { type: Number },
      fromPreviousDate: { type: Boolean },
    },
    data: function () {
      return {
        totalPoints: 0,
        selectedClass: null,
      };
    },
    created: function () {
      if (this.personId) {
        this.selectedClass = (this.classes as any)[0].id;
        this.reloadData();
      }
    },
    watch: {
      personId: function () {
        if (this.personId) { this.reloadData(); }
      },
      selectedClass: function () {
        this.reloadData();
      }
    },
    methods: {
      reloadData: function () {
        let year = new Date().getFullYear();

        if (this.fromPreviousDate) year -= 1;

        juniorHandlerService
          .getJuniorHandlerTotalPointsForYear(
            this.personId,
            this.scoreType,
            this.selectedClass!,
            year,
          ).then((data) => {
            this.totalPoints = data;
          });
      }
    }
});
</script>